import { render, staticRenderFns } from "./parkingBoxManageList.vue?vue&type=template&id=ac2519b4&scoped=true"
import script from "./parkingBoxManageList.vue?vue&type=script&lang=js"
export * from "./parkingBoxManageList.vue?vue&type=script&lang=js"
import style0 from "./parkingBoxManageList.vue?vue&type=style&index=0&id=ac2519b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2519b4",
  null
  
)

export default component.exports